let groupName = "";
import { onDestroy } from 'svelte';

export let setGroup = (_groupName) => {
    groupName = _groupName;

    onDestroy(() => {
        setTimeout(() => {
            groupName = "";
        }, 0)
    });
}

export let executeClientToGroup = (eventName, ...args) => {
    //console.log(`[debug] Execute client ${eventName}: ${args}`);
    if(window.mp !== undefined)
        window.mp.trigger("client" + groupName + eventName, ...args);
}

import rpc from 'rage-rpc';

// ── СТЕНД ПРЕВЬЮ ───────────────────────────────────────────────────────────
// В браузере игры нет, и запрос данных к клиенту (rage-rpc) никогда не
// отвечает: экраны, которые ждут ответа, остаются пустыми. Страница превью
// кладёт заготовленные ответы в window.__PREVIEW_RPC — здесь они и
// подставляются. В игре этого объекта нет, поведение не меняется.
const previewAnswer = (key, bare) => {
    try {
        const mock = window.__PREVIEW_RPC;
        if (!mock) return undefined;
        if (Object.prototype.hasOwnProperty.call(mock, key)) return mock[key];
        if (Object.prototype.hasOwnProperty.call(mock, bare)) return mock[bare];
    } catch (e) { }
    return undefined;
};

export let executeClientAsyncToGroup = async (eventName, ...args) => {
    const mocked = previewAnswer(groupName + eventName, eventName);
    if (mocked !== undefined)
        return typeof mocked === 'function' ? mocked(...args) : mocked;

    if(window.mp !== undefined)
        return await rpc.callClient ("rpc" + groupName + eventName, ...args);

    return null;
}

/////

export let executeClient = (eventName, ...args) => {
    //console.log(`[debug] Execute client ${eventName}: ${args}`);
    if(window.mp !== undefined)
        window.mp.trigger(eventName, ...args);
}

export let invokeMethod = (invokeName, ...args) => {
    //console.log(`[debug] Invoke method ${invokeName}: ${args}`);
    if(window.mp !== undefined) window.mp.invoke(invokeName, ...args);
}

export let executeClientAsync = async (eventName, ...args) => {
    const mocked = previewAnswer("." + eventName, eventName);
    if (mocked !== undefined)
        return typeof mocked === 'function' ? mocked(...args) : mocked;

    if(window.mp !== undefined)
        return await rpc.callClient ("rpc." + eventName, ...args);

    return null;
}